export default [
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/reports/ReportsView.vue'),
    meta: {
      resource: 'all',
      action: 'read',
    },
  },
]
